

















































































import { Component, Vue } from "vue-property-decorator";
import { AppConstants } from "@/core/Export";
import store from "@/store";

@Component({ components: {} })
export default class AppResidentLayout extends Vue {
  themeObj: Object = {
    "--primary": "#84bf41",
    "--secondary": "#0095da",
    "--accent": "#36353a",
    "--border": "#7d7d7f",
    "--font": "Heebo",
    "--font_size": "16px",
    "--main_bg": "#ffffff",
    "--label": "#0d5e35"
  };
  leftDrawerOpen = false;
  constructor() {
    super();
  }

  created() {
    this.updateThemeForCustomer();
  }

  updateThemeForCustomer() {
    let html = document.getElementsByTagName("html")[0];
    if (html) {
      Object.keys(this.themeObj).forEach(key => {
        html.style.setProperty(key, this.themeObj[key]);
      });
    }
  }

  onCloseErrorDialog() {
    this.appEnv.isErrorDialogVisible = false;
    this.appEnv.errorDialogMsgs = [];
  }

  get isNonLayoutRoute() {
    if (
      this.$route.name == AppConstants.Routes.RedRoute ||
      this.$route.name == AppConstants.Routes.ResidentApprovalPdf ||
      this.$route.name == AppConstants.Routes.GreenRouteForm
    ) {
      return true;
    } else {
      return false;
    }
  }

  get logoImg() {
    if (this.systemData && this.systemData["systemSettings"]) {
      var url:string = AppConstants.Http.BaseUrl;
      url=url.replace("/api","");
      return `${url}/logos/${this.systemData["systemSettings"].authorityCode}.png`;
    } else {
      return;
    }
  }

  get systemData() {
    return store.getters.systemData;
  }

  get appEnv() {
    return store.state.appEnv;
  }
}
